import type { AppGraphNodeType } from '../types'
import { NODE_TYPE_COLOR } from '../node-style'
import { useStudioLocale } from '@/i18n'

export interface LegendPanelProps {
  activeFilter: AppGraphNodeType | null
  onFilterChange: (t: AppGraphNodeType | null) => void
}

const TYPES: AppGraphNodeType[] = [
  'app',
  'page',
  'block',
  'atom',
  'flow',
  'stateVar',
  'datasource',
]

export function LegendPanel({ activeFilter, onFilterChange }: LegendPanelProps) {
  const { strings } = useStudioLocale()
  const copy = strings.appMap
  return (
    <section className="border-b border-border/40 px-3 py-3" aria-labelledby="legend-heading">
      <h3 id="legend-heading" className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {copy.legend.title}
      </h3>
      <ul className="space-y-1" role="listbox" aria-label={copy.legend.filterLabel}>
        {TYPES.map((t) => {
          const isActive = activeFilter === t
          return (
            <li key={t}>
              <button
                type="button"
                role="option"
                aria-selected={isActive}
                onClick={() => onFilterChange(isActive ? null : t)}
                className={
                  'flex w-full items-center gap-2 rounded-md px-2 py-1 text-left text-xs transition-colors ' +
                  (isActive
                    ? 'bg-muted text-foreground'
                    : 'text-muted-foreground hover:bg-muted/50 hover:text-foreground')
                }
              >
                <span
                  aria-hidden
                  className="h-2.5 w-2.5 shrink-0 rounded-full"
                  style={{
                    backgroundColor: NODE_TYPE_COLOR[t],
                    boxShadow: `0 0 6px ${NODE_TYPE_COLOR[t]}`,
                  }}
                />
                <span>{copy.nodeTypes[t]}</span>
              </button>
            </li>
          )
        })}
      </ul>
      {activeFilter !== null && (
        <button
          type="button"
          onClick={() => onFilterChange(null)}
          className="mt-2 text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground"
        >
          {copy.legend.clearFilter}
        </button>
      )}
    </section>
  )
}
